import { ResourceEnum } from "src/constants/constants.ts";
import type { ModuleOptions } from "src/system/module.types.ts";

export const module: ModuleOptions = {
  resource: ResourceEnum.StockMove,
  bigIcon: <i className={"icon-20-mov_gds"} />,
  smallIcon: <i className={"icon-15-mov_gds"} />,
  disableEdit: true,
  disableDelete: true,
};
